import { useQueryClient } from '@tanstack/react-query'

import { ClientError } from '@tribeplatform/gql-client/lib'

import { useMutation } from '../../lib/react-query/useMutation.js'
import { getPendingMessagesKey } from '../../utils/keys/messaging.key.js'
import { PendingMessage } from './usePendingMessages.js'

interface RemovePendingMessageArgs {
  chatId: string
  nonces: string[]
}

export const useRemovePendingMessage = () => {
  const queryClient = useQueryClient()

  return useMutation<PendingMessage[], ClientError, RemovePendingMessageArgs>(
    variables => {
      const pendingMessagesKey = getPendingMessagesKey({
        variables: { id: variables.chatId },
      })
      queryClient.setQueryData(
        pendingMessagesKey,
        (oldMessages: PendingMessage[] = []) => {
          return oldMessages.filter(
            message => !variables.nonces.includes(message.nonce),
          )
        },
      )
      return Promise.resolve([])
    },
  )
}
